import styled from "styled-components";

export const Title = styled.h3`
  font-size: 14px;
  font-weight: 200;
  padding: 15px 0;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 15px;
`;
